import { IApiResponse } from './iapi-response';
//used for vendor names for auto complete text boxes in search screen
export interface IVendorNamesResponse extends IApiResponse {
  vendorName: string;
  vendorType: string;
}
